import { type Row } from "@tanstack/react-table";
import { Link } from "react-router-dom";
import { TableCell } from "./TableCell";

export const TableRow = ({
	height,
	translateY,
	row,
	getRowUrl,
}: {
	height: number;
	translateY: number;
	row: Row<any>;
	getRowUrl?: (row: any) => string;
}) => {
	const rowUrl = getRowUrl ? getRowUrl(row.original) : "";

	const rowComponent = (
		<div
			className="group absolute top-0 left-0 min-w-full bg-white flex items-center border-b border-b-gray-100 text-[15px] text-gray-700 cursor-pointer hover:bg-[rgba(251,252,253,1)] hover:text-gray-950 last:border-gray-100 z-10"
			style={{
				height: `${height}px`,
				transform: `translateY(${translateY}px)`,
			}}
			onClick={row.getCanExpand() ? row.getToggleExpandedHandler() : undefined}
			data-testid="data-table-row"
		>
			{row.getVisibleCells().map((cell, index) => {
				return (
					<TableCell
						key={index}
						cell={cell}
						noTruncate={
							(cell.column.columnDef.meta as { noTruncate?: boolean } | undefined)?.noTruncate ??
							false
						}
						centerItems={
							(cell.column.columnDef.meta as { centerItems?: boolean } | undefined)?.centerItems ??
							false
						}
					/>
				);
			})}
		</div>
	);

	return rowUrl !== "" ? (
		<Link to={rowUrl} rel="noopener noreferrer" tabIndex={-1}>
			{rowComponent}
		</Link>
	) : (
		rowComponent
	);
};
